webpackJsonp([0,2],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var vueScrollResponse = {};

vueScrollResponse.install = function (Vue) {
  Vue.directive('scroll-response', {
    inserted: function inserted(el, _ref, vnode) {
      var value = _ref.value;

      var contentScrollEl = document.getElementById(value.contentId);
      var catalogScrollEl = document.getElementById(value.catalogId);

      var contentTitles = contentScrollEl.querySelectorAll(value.title);
      var catalogTitles = catalogScrollEl.querySelectorAll(value.title);

      var oldActiveIndex = 0;
      var titlesTopArr = [];

      var initTitlesTopArr = function initTitlesTopArr() {
        for (var i = 1; i < contentTitles.length; i++) {

          titlesTopArr.push(contentTitles[i].offsetTop);
        }

        titlesTopArr.push(contentScrollEl.scrollHeight);
      };

      initTitlesTopArr();

      var _removeClass = function _removeClass(el, className) {
        el.className = el.className.replace(className, '');
      };

      var _addClass = function _addClass(el, className) {
        el.className += ' ' + className;
      };

      _addClass(catalogTitles[0], 'catalog-active');
      if (value.contentTitleActive != 'off') _addClass(contentTitles[0], 'catalog-active');

      var addActiveClass = function addActiveClass(e) {
        var sTop = e.target.scrollTop;
        for (var i = 0; i < titlesTopArr.length; i++) {
          if (sTop < titlesTopArr[i]) {
            if (i != oldActiveIndex) {
              _addClass(catalogTitles[i], 'catalog-active');
              _removeClass(catalogTitles[oldActiveIndex], 'catalog-active');

              if (value.contentTitleActive != 'off') {
                _addClass(contentTitles[i], 'catalog-active');
                _removeClass(contentTitles[oldActiveIndex], 'catalog-active');
              }
              oldActiveIndex = i;
            }
            break;
          }
        }
      };

      var catalogMiss = function catalogMiss() {
        var activeCatalog = catalogScrollEl.getElementsByClassName('catalog-active')[0];

        if (activeCatalog.offsetTop + activeCatalog.offsetHeight >= catalogScrollEl.scrollTop + catalogScrollEl.clientHeight) {
          catalogScrollEl.scrollTop = activeCatalog.offsetTop;
        } else if (activeCatalog.offsetTop < catalogScrollEl.scrollTop) {
          catalogScrollEl.scrollTop = activeCatalog.offsetTop - catalogScrollEl.offsetHeight + activeCatalog.offsetHeight * 2;
        }
      };

      var contentScroll = function contentScroll(e) {
        addActiveClass(e);
        catalogMiss();
      };

      contentScrollEl.addEventListener('scroll', contentScroll);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = vueScrollResponse;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(4),
  /* template */
  __webpack_require__(10),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_test_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_test_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_test_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    test: __WEBPACK_IMPORTED_MODULE_0__components_test_vue___default.a
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'vue-scroll-response',
  data: function data() {
    return {
      msg: 'this is from vue-scroll-response.vue',
      testData: [{
        title: '一级目录1',
        children: [{ title: '二级目录11' }, { title: '二级目录12' }, { title: '二级目录13' }]
      }, {
        title: '一级目录2',
        children: [{ title: '二级目录21' }, { title: '二级目录22' }, { title: '二级目录23' }]
      }, {
        title: '一级目录3',
        children: [{ title: '二级目录31' }, { title: '二级目录32' }, { title: '二级目录33' }]
      }, {
        title: '一级目录4',
        children: [{ title: '二级目录41' }, { title: '二级目录42' }, { title: '二级目录43' }]
      }, {
        title: '一级目录5',
        children: [{ title: '二级目录51' }, { title: '二级目录52' }, { title: '二级目录53' }]
      }, {
        title: '一级目录6',
        children: [{ title: '二级目录61' }, { title: '二级目录62' }, { title: '二级目录63' }]
      }, {
        title: '一级目录7',
        children: [{ title: '二级目录71' }, { title: '二级目录72' }, { title: '二级目录73' }]
      }, {
        title: '一级目录8',
        children: [{ title: '二级目录81' }, { title: '二级目录82' }, { title: '二级目录83' }]
      }, {
        title: '一级目录9',
        children: [{ title: '二级目录91' }, { title: '二级目录92' }, { title: '二级目录93' }]
      }],
      titlesTopArr: [],
      contentEl: null,
      catalogEl: null,
      contentTitles: null,
      catalogTitles: null,
      activeIndex: ''

    };
  },

  methods: {}

};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(6)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-scroll-response-test"
  }, [_c('div', {
    attrs: {
      "id": "catalog"
    }
  }, _vm._l((_vm.testData), function(v1) {
    return _c('div', {
      staticClass: "catalog-item"
    }, [_c('h1', {
      staticClass: "title"
    }, [_c('a', {
      attrs: {
        "href": '#' + v1.title
      }
    }, [_vm._v(_vm._s(v1.title))])]), _vm._l((v1.children), function(v2) {
      return (v1.children) ? _c('h2', {
        staticClass: "title"
      }, [_c('a', {
        attrs: {
          "href": '#' + v2.title
        }
      }, [_vm._v(_vm._s(v2.title))])]) : _vm._e()
    })], 2)
  })), _c('div', {
    ref: "content",
    attrs: {
      "id": "content"
    }
  }, _vm._l((_vm.testData), function(v1) {
    return _c('div', {
      staticClass: "content-item"
    }, [_c('h1', {
      staticClass: "title",
      attrs: {
        "id": v1.title
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + v1.title
      }
    }, [_vm._v(_vm._s(v1.title))])]), _vm._l((v1.children), function(v2) {
      return (v1.children) ? _c('h2', {
        staticClass: "title",
        attrs: {
          "id": v2.title
        }
      }, [_c('a', {
        attrs: {
          "href": '#' + v2.title
        }
      }, [_vm._v(_vm._s(v2.title))])]) : _vm._e()
    })], 2)
  }))])
},staticRenderFns: []}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('test', {
    directives: [{
      name: "scroll-response",
      rawName: "v-scroll-response",
      value: ({
        title: '.title',
        contentId: 'content',
        catalogId: 'catalog'
      }),
      expression: "{title:'.title',contentId:'content',catalogId:'catalog'}"
    }]
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directive_vue_scroll_response_js__ = __webpack_require__(1);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2__directive_vue_scroll_response_js__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[13]);


// WEBPACK FOOTER //
// static/js/app.c4392aec7e492903584b.js